import {createUseStyles} from 'react-jss';

export default createUseStyles({
  detailedTooltipIcon: {
    display: 'inline-block',
    marginLeft: 8,
    padding: 0,
    width: 'auto',
    position: 'relative',
    lineHeight: '36px',
    fontSize: 14,
  },
  button: {
    width: 'auto',
    height: 'auto',
    background: 'none',
    border: 'none',
    maxWidth: 'none',
    padding: 0,
  },
  image: {
    width: 20,
  },
});
